<template>
    <v-form v-model="testRegFormValid">
        <v-container>
            <v-layout wrap>
                <v-flex xs12 sm12 md12 pr-3>
                    <v-text-field id="testRegPart1" prepend-icon="vpn_key" name="test_reg_part1" class="notranslate"
                                  label="Код в формате XXXXXX-XXXXXX" v-model="testReg.key"
                                  mask="NNNNNN-NNNNNN"
                                  :rules="[rules.required]"
                                  type="text"
                                  required></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-btn block large color="primary"
                           :disabled="!testRegFormValid"
                           @click="addTestCode">Сохранить
                    </v-btn>
                </v-flex>
                {{testReg.part1}}
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: "RegTest",
        data: () => ({
            testRegFormValid: false,
            testRegFormIsDirty: false,
            testReg: {
                key: "",
                formatted: ""
            },
            utility: {},
            rules: {
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters'
            }
        }),
        watch: {
            'testReg.key': {
                handler: function (val) {
                    this.testReg.formatted = val.slice(0, 6) + '-' + val.slice(6)
                }
            }
        },
        methods: {
            addTestCode: function () {
                var this_ = this;
                let key = this_.testReg.formatted
                this.$store.dispatch('addTestCode', {key}).then(function (response) {
                    this_.response = response
                    this_.$store.dispatch('processError', this_.response)
                    if (this_.response.status === 200) {
                        if (!this_.$store.state.user.checks.profile) this_.$router.push('/home/profile')
                        else if (!this_.$store.state.user.testcodes.length) this_.$router.push('/home/tests/reg')
                        else this_.$router.push('/')
                    }

                })
            },
        },
        computed: {
            profileFormCanSave: function () {
                if (this.profileFormValid && this.isProfileFormIsDirty) return true;
                return false;
            }
        }/*,
        created: function () {
        }*/

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
</style>